import { Skeleton as UiSkeleton, styled } from "@l2r-front/l2r-ui"

export const Skeleton = styled(UiSkeleton)({
    height: 24,
    transform: "scale(1)",
    width: 220,
})